import axios from "axios";
import Cookies from "js-cookie";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  (config) => {
    config.headers.token = Cookies.get("authToken");

    config.data = {
      ...config.data,
      ProjectIDs: localStorage.getItem("projectId") || "",
    };

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;